(function () {
  "use strict";
  // Explicit diagnostic navigation. Server-side exclusion requires a signed proof.
  if (/(?:[?&])growth_measurement=[^&]+/.test(location.search||'') && /(?:[?&])community_view=growth(?:&|$)/.test(location.search||'')) return;
  if (window.WppAnalytics || window.Shopify?.designMode) return;
  const script = document.querySelector("script[data-wpp-analytics]");
  if (!script) return;
  let config;
  try {
    config = JSON.parse(script.textContent);
  } catch {
    return;
  }
  if (!config.endpoint || !/^https:\/\//.test(config.endpoint)) return;
  const endpoint = config.endpoint.replace(/\/$/, "") + "/collect";
  // Remember this as a test browser across logout; reports choose whether to
  // include it. No customer ID or email is sent to analytics.
  const TEST_BROWSER = "wpp.analytics.test.v1";
  let testTraffic = config.testTraffic === true;
  try {
    testTraffic = testTraffic || localStorage.getItem(TEST_BROWSER) === "true";
    if (testTraffic) localStorage.setItem(TEST_BROWSER, "true");
  } catch {}
  const VISITOR = "wpp.analytics.visitor.v1",
    SESSION = "wpp.analytics.session.v1",
    LANGUAGE = "wpp.analytics.language.v1";
  const ttl = 30 * 60 * 1000;
  let active = false,
    visitor,
    session,
    pageId,
    events = [],
    inFlight = false,
    generation = 0;
  let activeMs = 0,
    scroll = 0,
    lastTick = Date.now(),
    lastInteraction = 0,
    openedInput = false;
  let pageCount = 0,
    wasVisible = document.visibilityState === "visible";
  let lastAction = "";
  const communityActions = {
    growth_view: "commander_growth", growth_full_view: "commander_growth",
    growth_unlock_start: "commander_growth", growth_unlock_success: "commander_growth",
    growth_unlock_existing: "commander_growth", growth_unlock_insufficient: "commander_growth",
    growth_unlock_error: "commander_growth", growth_load_error: "commander_growth",
    growth_unlock_unavailable: "commander_growth",
    growth_compare_power: "commander_growth", growth_compare_kills: "commander_growth",
    growth_records_open: "commander_growth",
    profile_save_start: "warpath_profile", profile_registered: "warpath_profile",
    profile_updated: "warpath_profile", profile_incomplete: "warpath_profile",
    profile_save_error: "warpath_profile",
  };
  const growthViews = new WeakMap();
  function community(action, operationId) {
    if (!Object.hasOwn(communityActions, action)) return;
    if (/^profile_|^growth_unlock_/.test(action) && !/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(operationId || "")) return;
    emit("community_activity", {feature: communityActions[action], element: action, operation_id: operationId || ""});
    // Save results must survive the redirect from community registration.
    if (/^profile_|^growth_unlock_/.test(action)) void flush(true);
  }
  function growthView(element) {
    if (!active || !allowed() || !element) return;
    touchSession();
    const access = element.getAttribute("data-analytics-growth-access");
    if (!["free", "full"].includes(access) || growthViews.get(element) === pageId) return;
    growthViews.set(element, pageId);
    community(access === "full" ? "growth_full_view" : "growth_view");
  }
  const id = () => crypto.randomUUID();
  const stored = (key) => {
    try {
      return JSON.parse(localStorage.getItem(key) || "null");
    } catch {
      return null;
    }
  };
  const save = (key, value) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {}
  };
  const remove = (key) => {
    try {
      localStorage.removeItem(key);
    } catch {}
  };
  const allowed = () => {
    try {
      return (
        window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true
      );
    } catch {
      return false;
    }
  };
  const cleanToken = (value) =>
    typeof value === "string" && /^[a-zA-Z0-9_.:-]{0,100}$/.test(value)
      ? value
      : "";
  const cleanPath = (raw) => {
    if (!raw) return "";
    try {
      const url = new URL(raw, location.href);
      if (!["http:", "https:"].includes(url.protocol)) return "";
      const p = url.pathname;
      if (/%(?:40|2f|5c)|@/i.test(p)) return "/[redacted]";
      if (
        /\/(?:account|checkout|checkouts|authentication|orders|apps)(?:\/|$)/i.test(
          p,
        )
      )
        return "/[private]";
      return p
        .slice(0, 400)
        .replace(/[0-9a-f]{8}-[0-9a-f-]{27,}/gi, "[id]")
        .replace(/\/\d{6,}(?=\/|$)/g, "/[id]");
    } catch {
      return "";
    }
  };
  const externalReferrer = () => {
    try {
      const u = new URL(document.referrer);
      return u.origin === location.origin
        ? u.origin + cleanPath(u.pathname)
        : u.origin;
    } catch {
      return "";
    }
  };
  function elementName(el) {
    const explicit = cleanToken(el.getAttribute("data-analytics-id"));
    if (explicit) return explicit;
    if (el.closest("[data-wpp-damage-cycle]")) {
      for (const attr of [
        "data-cycle-submit",
        "data-cycle-reset",
        "data-cycle-edit",
        "data-cycle-officer-picker-button",
        "data-cycle-officer-b-picker-button",
        "data-cycle-unit-picker-button",
        "data-cycle-star-picker-button",
        "data-cycle-target-unit-picker-button",
        "data-cycle-defender-captain-picker-button",
        "data-cycle-defender-aide-picker-button",
      ]) {
        if (el.hasAttribute(attr))
          return "calculator." + attr.slice(11).replaceAll("-", "_");
      }
      if (el.getAttribute("type") === "submit") return "calculator.calculate";
    }
    const section = el.closest("[id^='shopify-section-']");
    const region = section
      ? cleanToken(
          section.id
            .replace(/^shopify-section-/, "")
            .replace(/template--[0-9]+__|sections--[0-9]+__/g, ""),
        )
      : "";
    return (
      (region || (el.closest("header,nav") ? "navigation" : "content")) +
      "." +
      el.tagName.toLowerCase()
    );
  }
  const campaign = new URLSearchParams(location.search);
  function base(name, details) {
    return {
      event_id: id(),
      occurred_at: Date.now(),
      visitor_id: visitor.id,
      session_id: session.id,
      page_id: pageId,
      name,
      path: cleanPath(location.pathname),
      locale: config.locale || document.documentElement.lang,
      browser_locale: navigator.languages?.[0] || navigator.language || "",
      preferred_locale: stored(LANGUAGE) || "",
      available_locales: config.availableLocales || [],
      returning: visitor.returning,
      referrer: externalReferrer(),
      source: cleanToken(campaign.get("utm_source")),
      medium: cleanToken(campaign.get("utm_medium")),
      campaign: cleanToken(campaign.get("utm_campaign")),
      feature: config.feature || "",
      active_ms: activeMs,
      scroll_percent: scroll,
      ...details,
    };
  }
  function beginPage() {
    pageId = id();
    activeMs = 0;
    scroll = 0;
    openedInput = false;
    lastAction = "";
    pageCount = 0;
    lastTick = Date.now();
    lastInteraction = 0;
    events.push(base("page_view", {}));
    if (config.pageType === "404") events.push(base("not_found", {}));
    if (config.feature) events.push(base("feature_open", {}));
  }
  let sessionStorageAt=-Infinity;
  function touchSession() {
    const now = Date.now(),
      sync=!session||now-sessionStorageAt>=5000,
      existing = sync?stored(SESSION):session;
    if (existing?.id && existing.last > now - ttl && existing.last <= now) {
      if (session && session.id !== existing.id) {
        session = existing;
        beginPage();
      } else session = existing;
    } else if (!session || session.last <= now - ttl) {
      session = {
        id: id(),
        last: now,
        returning: Boolean(pageId) || visitor.returning,
      };
      visitor.returning = session.returning;
      if (pageId) beginPage();
    }
    session.last = now;
    if(sync){sessionStorageAt=now;save(SESSION, session);}
  }
  function emit(name, details = {}) {
    if (!active || !allowed()) return;
    touchSession();
    if (++pageCount > 1000 || events.length >= 120) return;
    events.push(base(name, details));
    if (events.length >= 15) void flush();
  }
  async function flush(beacon = false) {
    if (!active || !allowed() || !events.length || inFlight) return;
    const batch = events.splice(0, 30),
      payload = JSON.stringify({ consent: true, test_traffic: testTraffic, events: batch });
    const epoch = generation;
    if (beacon && navigator.sendBeacon) {
      if (
        navigator.sendBeacon(
          endpoint,
          new Blob([payload], { type: "text/plain;charset=UTF-8" }),
        )
      )
        return;
    }
    inFlight = true;
    try {
      const response = await fetch(endpoint, {
        method: "POST",
        body: payload,
        headers: { "Content-Type": "text/plain;charset=UTF-8" },
        credentials: "omit",
        keepalive: true,
      });
      if (
        !response.ok &&
        response.status !== 400 &&
        response.status !== 403 &&
        epoch === generation &&
        active
      )
        events = batch.concat(events).slice(0, 120);
    } catch {
      if (epoch === generation && active)
        events = batch.concat(events).slice(0, 120);
    } finally {
      inFlight = false;
    }
  }
  function reconcileConsent() {
    if (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed) return;
    if (allowed()) {
      if (active) return;
      active = true;
      generation++;
      const existing = stored(VISITOR),
        now = Date.now();
      visitor =
        existing?.id && existing.expires > now
          ? { ...existing, returning: true }
          : { id: id(), expires: now + 90 * 86400000, returning: false };
      save(VISITOR, visitor);
      touchSession();
      visitor.returning = session.returning ?? visitor.returning;
      session.returning = visitor.returning;
      save(SESSION, session);
      beginPage();
      document.querySelectorAll?.("[data-analytics-growth-access]").forEach(growthView);
      void flush();
    } else {
      active = false;
      generation++;
      events = [];
      visitor = session = pageId = null;
      remove(VISITOR);
      remove(SESSION);
      remove(LANGUAGE);
    }
  }
  function tick() {
    const now = Date.now();
    if (active && allowed() && wasVisible && now - lastInteraction < 60000) {
      activeMs += Math.max(0, Math.min(15000, now - lastTick));
      emit("engagement");
    }
    lastTick = now;
    wasVisible = document.visibilityState === "visible";
    void flush();
  }
  let lastLanguageChoice = "";
  function language(value) {
    if (
      !active ||
      !allowed() ||
      !/^[a-z]{2,3}(-[a-z0-9]{2,8})*$/i.test(value || "")
    )
      return;
    value = value.toLowerCase();
    if (
      value ===
        (config.locale || document.documentElement.lang).toLowerCase() ||
      value === lastLanguageChoice
    )
      return;
    lastLanguageChoice = value;
    emit("language_choice", {
      element: "navigation.language_switch",
      destination: "/" + value.toLowerCase(),
    });
    save(LANGUAGE, value.toLowerCase());
    void flush(true);
  }
  for (const type of ["pointerdown", "keydown", "scroll"])
    document.addEventListener(
      type,
      (event) => {
        if (!event.isTrusted || !active || !allowed()) return;
        lastInteraction = Date.now();
        if (type === "scroll") {
          const height = document.documentElement.scrollHeight - innerHeight;
          scroll = Math.max(
            scroll,
            height > 0
              ? Math.min(100, Math.round((scrollY / height) * 100))
              : 100,
          );
        }
      },
      { passive: true },
    );
  document.addEventListener(
    "click",
    (event) => {
      if (
        !event.isTrusted ||
        !active ||
        !allowed() ||
        !(event.target instanceof Element)
      )
        return;
      const el = event.target.closest(
        "[data-analytics-id],a,button,[role='tab'],summary",
      );
      if (
        !el ||
        el.closest(
          "[data-analytics-ignore],input,textarea,[contenteditable='true']",
        )
      )
        return;
      const href = el.getAttribute("href");
      lastAction = elementName(el);
      emit("click", {
        element: elementName(el),
        destination: cleanPath(href),
      });
      if (["language_code", "locale_code"].includes(el.getAttribute("name")))
        language(el.value);
      else if (el.getAttribute("hreflang"))
        language(el.getAttribute("hreflang"));
      if (href) void flush(true);
    },
    true,
  );
  document.addEventListener(
    "change",
    (event) => {
      if (!event.isTrusted || !(event.target instanceof Element)) return;
      if (
        ["language_code", "locale_code"].includes(
          event.target.getAttribute("name"),
        )
      )
        language(event.target.value);
      if (
        config.feature &&
        !openedInput &&
        event.target.closest("[data-wpp-damage-cycle]")
      ) {
        openedInput = true;
        emit("feature_input");
      }
    },
    true,
  );
  document.addEventListener(
    "submit",
    (event) => {
      if (!event.isTrusted) return;
      const submitter = event.submitter;
      const value = ["language_code", "locale_code"].includes(
        submitter?.getAttribute("name"),
      )
        ? submitter.value
        : event.target.querySelector?.(
            'select[name="language_code"],select[name="locale_code"],input[name="language_code"],input[name="locale_code"]',
          )?.value;
      if (value) language(value);
    },
    true,
  );
  function diagnostics(reason, filename, line, column) {
    // Classify locally; arbitrary error messages and full stacks may contain
    // form input, tokens or personal data and are deliberately never sent.
    let message = "", stack = "", name = "";
    try {
      message = typeof reason === "string" ? reason : String(reason?.message || "");
      stack = String(reason?.stack || "");
      name = String(reason?.name || "");
    } catch {}
    const category = /abort/i.test(name + " " + message) ? "aborted"
      : /timeout|timed out/i.test(message) ? "timeout"
      : /failed to fetch|load failed|networkerror|network request failed/i.test(message) ? "network_failed"
      : /cannot read|undefined is not an object|null is not an object/i.test(message) ? "property_access"
      : /not a function/i.test(message) ? "not_function"
      : /not defined|can't find variable/i.test(message) ? "undefined_variable"
      : /syntaxerror/i.test(name) ? "syntax_error"
      : /securityerror|quotaexceedederror/i.test(name) ? "storage_denied" : "unknown";
    const frame = stack.match(/(https?:\/\/[^\s)]+):(\d+):(\d+)/);
    let source = "";
    try {
      const url = new URL(filename || frame?.[1]);
      if (["http:", "https:"].includes(url.protocol)) source = url.origin + cleanPath(url.pathname);
    } catch {}
    return {element: lastAction, error_category: category, error_source: source,
      error_line: Number(line || frame?.[2]) || 0, error_column: Number(column || frame?.[3]) || 0};
  }
  window.addEventListener("error", (event) => {
    if (event instanceof ErrorEvent)
      emit("js_error", {
        error_code: "uncaught_error",
        destination: cleanPath(event.filename),
        ...diagnostics(event.error || event.message, event.filename, event.lineno, event.colno),
      });
  });
  window.addEventListener("unhandledrejection", (event) =>
    emit("js_error", { error_code: "unhandled_rejection", ...diagnostics(event.reason) }),
  );
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") {
      tick();
      void flush(true);
    } else {
      wasVisible = true;
      lastTick = Date.now();
      lastInteraction = 0;
    }
  });
  window.addEventListener("pagehide", () => {
    emit("engagement");
    void flush(true);
  });
  window.addEventListener("pageshow", (event) => {
    if (event.persisted && active && allowed()) {
      touchSession();
      beginPage();
      void flush();
    }
  });
  document.addEventListener("visitorConsentCollected", reconcileConsent);
  window.addEventListener("storage", (event) => {
    if (event.key === TEST_BROWSER && event.newValue === "true") testTraffic = true;
    if (event.key === VISITOR && !event.newValue) {
      active = false;
      events = [];
      pageId = session = visitor = null;
      generation++;
    }
  });
  window.WppAnalytics = Object.freeze({
    community,
    growthView,
    calculator(name, operationId, code) {
      if (
        !config.feature ||
        !["feature_start", "feature_result", "feature_error"].includes(name)
      )
        return;
      emit(name, {
        operation_id: operationId || "",
        error_code: cleanToken(code),
      });
    },
    permitted() {
      return active && allowed() && Boolean(config.feature);
    },
  });
  if (window.Shopify?.loadFeatures)
    window.Shopify.loadFeatures(
      [{ name: "consent-tracking-api", version: "0.1" }],
      (error) => {
        if (!error) reconcileConsent();
      },
    );
  reconcileConsent();
  setInterval(tick, 15000);
})();
